'use client'

import { cn } from '@brew/ui/cn'
import { PlanGrid } from '@/components/billing/plan-grid'
import { useAppLocale } from '@/components/i18n/locale-provider'
import { ENTERPRISE_PAGE_HREF } from '@/components/marketing/sections/pricing-comparison-labels'
import type { BillingOverview, BillingPriceSummary } from '@/lib/billing/types'
import { localizePath } from '@/lib/i18n/routing'

interface PricingSectionProps {
  initialBillingOverview?: BillingOverview | null
  priceSummaries: BillingPriceSummary
  showEnterprise?: boolean
  className?: string
}

/**
 * The plan cards. The page that renders them owns the heading above them
 * (the `/pricing` hero).
 */
export function PricingSection({
  initialBillingOverview,
  priceSummaries,
  showEnterprise = true,
  className,
}: PricingSectionProps) {
  const locale = useAppLocale()
  return (
    <section className={cn('w-full', className)}>
      <div className="w-full">
        <PlanGrid
          billingOverview={initialBillingOverview}
          priceSummaries={priceSummaries}
          showEnterprise={showEnterprise}
          enterpriseHref={localizePath(locale, ENTERPRISE_PAGE_HREF)}
        />
      </div>
    </section>
  )
}
